import { DeleteIcon, DoubleArrowIcon } from "../../../../../assets/icons";

export const ContractExpiredCard = ({ title, description, onRetry }) => (
  <div className="w-full max-w-sm lg:max-w-md rounded-xl border border-warning/25 bg-warning/10 p-4 text-left shadow-sm">
    <div className="flex items-start gap-3">
      <span
        aria-hidden="true"
        className="mt-0.5 inline-flex h-8 w-8 items-center justify-center rounded-full bg-warning/20 text-warning"
      >
        <DeleteIcon width={16} height={16} />
      </span>
      <div className="min-w-0 flex-1">
        <p className="text-sm font-semibold text-warning truncate">
          {title || "Contract generation timed out"}
        </p>
        <p className="mt-1 text-xs text-warning/80 text-pretty">
          Contract generation timed out. You can try again.
        </p>
        {description && (
          <p className="mt-1 text-xs text-warning/70 text-pretty line-clamp-3">
            {description}
          </p>
        )}
        {onRetry && (
          <button
            type="button"
            onClick={onRetry}
            className="mt-3 inline-flex items-center gap-1.5 text-xs font-semibold text-warning hover:text-warning transition-colors cursor-pointer"
          >
            Try again
            <DoubleArrowIcon width={12} height={12} className="text-warning" />
          </button>
        )}
      </div>
    </div>
  </div>
);
